/* tslint:disable */
/* eslint-disable */
export enum BinFileStatusEnum {
  Received = 'Received',
  Processing = 'Processing',
  Processed = 'Processed'
}
